import React from "react";
import PropTypes from "prop-types";

const BuildUpIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  selected,
  ...props
}) => {
  const strokeColor = stroke && stroke !== "currentColor" ? stroke : color || "#666666";

  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      opacity={selected ? 1 : undefined}
      className={className}
      {...props}
    >
      <path
        d="M10.0004 8L3.7517 14.2487C3.19978 14.8008 2.30346 14.8009 1.75136 14.249C1.19926 13.6971 1.19912 12.8008 1.75103 12.2487L8.00036 6"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.33333"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9.99992L14.6667 7.33325"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.33333"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3333 7.66667L13.0573 6.39067C12.8073 6.14068 12.6667 5.80159 12.6667 5.448V5.21867C12.6666 4.86507 12.5261 4.52599 12.276 4.276L11.1713 3.17133C10.4214 2.42154 9.40445 2.00023 8.344 2H6L6.82867 2.82867C7.57862 3.57875 7.99995 4.59598 8 5.65667V6.66667L9.33333 8H10.1147C10.4683 8.00008 10.8073 8.1406 11.0573 8.39067L12.3333 9.66667"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.33333"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

BuildUpIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  selected: PropTypes.bool,
};

BuildUpIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
  selected: false,
};

export default BuildUpIcon;
